import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {change, Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import {
    SelectInput,
    TextInput
} from 'admin-on-rest';
import DateRangeFields from './DateRangeFields';
import ReportJobsFilter from './ReportJobsFilter';
import SecondaryFilterFieldsWithLocations from './SecondaryFilterFieldsWithLocations';
import {assembleReportJobPayload, setReportJobParams, setReportJobFormDetails} from '../shared/reportJobFunctions';
import {convertDate} from '../shared/functions';
import {commonStyles} from '../shared/styles';
import {filterStyles} from '../shared/styles-filter';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';

const renderTextInput = ({meta: {touched, error} = {}, input: {...inputProps}, ...props}) => {
    return (
        <TextField
            errorText={touched && error}
            {...inputProps}
            {...props}
            fullWidth
        />
    )
};

/**
 * (DEPRECATED)
 */
class CreateReportJobForm extends Component {
    constructor(props) {
        super(props);
        const currentYear = new Date().getFullYear();
        const endMaxDate = new Date();
        const startMinDate = new Date();
        const startMaxDate = new Date();
        startMinDate.setFullYear(currentYear - 10);
        startMaxDate.setDate(startMaxDate.getDate() - 1);
        this.state = {
            details: {
                name: '',
                description: '',
                instructions: ''
            },
            endMaxDate: endMaxDate,
            includeFields: {
                active: false,
                dateRange: false,
                fraudLocked: false,
                offset: false,
                locations: false,
                top: false
            },
            reportType: '',
            startMaxDate: startMaxDate,
            startMinDate: startMinDate
        };

        this.getFormValues = this.getFormValues.bind(this);
        this.handleFieldUpdate = this.handleFieldUpdate.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.validateForm = this.validateForm.bind(this);
    }

    getFormValues = () => {
        return JSON.parse(JSON.stringify(this.props.formValues));
    }

    handleReportTypeSelect = (e) => {
        // Get text details from Report Job Type
        const details = setReportJobFormDetails(e.value);
        // Set which fields should be displayed based on this Report Job Type
        const includeFields = setReportJobParams(e.value);
        this.setState({
            details: details,
            includeFields: includeFields,
            reportType: e.value
        }, () => {
            this.props.dispatch(change('jobReportForm', 'report_type', this.state.reportType));
            this.props.dispatch(change('jobReportForm', 'name', ''));
            this.props.dispatch(change('jobReportForm', 'description', ''));
            if (includeFields.active) {
                this.props.dispatch(change('jobReportForm', 'active', true));
            }
            if (includeFields.fraudLocked) {
                this.props.dispatch(change('jobReportForm', 'fraud_locked', false));
            }
            if (includeFields.top) {
                this.props.dispatch(change('jobReportForm', 'top', 1));
            }
        });

    };

    handleDateSelect(field, value) {
        if (field && value) {
            let fieldName = null;
            switch (field) {
                case 'end_date':
                    fieldName = 'date_to';
                    break;
                case 'start_date':
                    fieldName = 'date_from';
                    break;
                default:
                    break;
            }
            // Convert date selection from YYYY-MM-DDT00:00:00.000Z to yyyy-mm-dd
            let convertedValue = convertDate(value, 'query', false, true, null);
            this.props.dispatch(change('jobReportForm', fieldName, convertedValue));
        }
    }

    handleFieldUpdate(field, index, event) {
        // Convert dates
        let fieldValue = (index) ? index : null;
        if (field === 'start_date' || field === 'end_date') {
            this.handleDateSelect(field, fieldValue);
        }
        // Convert Location ID
        if (this.props.formValues.filter_types && this.props.formValues.filter_types === 'location') {
            if (field === 'filterChoice') {
                this.props.dispatch(change('jobReportForm', 'filter_first_choice', index.toString()));
            }
        }
        // Store any specific multiple Locations from Secondary Filter
        if (field === 'filterLocations') {
            let locations = [];
            index.forEach(function (loc, idx) {
                locations.push(loc.toString());
            });
            this.props.dispatch(change('jobReportForm', 'filter_locations', locations));
        }
    }

    validateName = (value) => {
        let error = false;
        if (!value || value === '') {
            error = 'Name is required.';
        }
        return error;
    };

    validateTop = (value) => {
        let error = false;
        if (value && value < 1) {
            error = 'Must request at least one row.';
        }
        if (value && value > 10000) {
            error = 'Maximum 10,000 results allowed.';
        }
        return error;
    };

    validateForm = () => {
        if (this.props && this.props.formValues) {
            const val = this.getFormValues();
            const include = this.state.includeFields;
            if (val) {
                const filterTypes = (val.filter_types) ? val.filter_types : null;
                let top = (val.top) ? parseInt(val.top, 10) : null;
                if (
                    !val.name || val.name === '' ||
                    (include.top && (!top || top < 1 || top > 10000)) ||
                    (include.dateRange && (!val.date_from || !val.date_to)) ||
                    (include.offset && (!val.offset)) ||
                    (filterTypes && filterTypes !== 'locations' && filterTypes !== 'all' && !val.filter_first_choice) ||
                    (filterTypes === 'locations' && (!val.filter_locations || val.filter_locations.length === 0))
                ) {
                    return false;
                }
                return true;
            }
        }
        return false;
    };

    handleSubmit = () => {
        const reportType = this.state.reportType;
        const formValues = JSON.parse(JSON.stringify(this.props.formValues));
        const payload = assembleReportJobPayload(reportType, formValues);

        if (typeof this.props.onFormComplete === 'function') {
            this.props.onFormComplete(payload);
        }
    };

    render() {
        const {
            formValues,
            submitted,
            submitting,
            success
        } = this.props;

        const {
            details,
            endMaxDate,
            includeFields,
            reportType,
            startMaxDate,
            startMinDate
        } = this.state;

        return (
            <div className="list-filter">
                <form>
                    <ReportJobsFilter
                        instructions={false}
                        clearable={false}
                        fullWidth={true}
                        onFilterChange={(e) => this.handleReportTypeSelect(e)}
                    />

                    {reportType &&
                        <Fragment>
                            <hr style={commonStyles.divider}/>
                            <h3>{details.name}</h3>
                            <div style={commonStyles.mt2}>
                                <p>
                                    {details.description}
                                </p>
                                <p>
                                    {details.instructions}
                                </p>
                            </div>

                            <Field
                                name="name"
                                component={TextInput}
                                label="Report Job Name *"
                                required
                                validate={[this.validateName]}
                                elStyle={filterStyles.selectInputFull}
                            />

                            <Field
                                name="description"
                                component={TextInput}
                                label="Report Job Description"
                                elStyle={filterStyles.selectInputFull}
                            />

                            {/* Active and Fraud-Locked */}
                            {includeFields.active &&
                                <Fragment>
                                    <hr style={filterStyles.break}/>
                                    <Field
                                        name="active"
                                        component={SelectInput}
                                        label="Active Accounts?"
                                        choices={[
                                            {id: true, name: 'Yes'},
                                            {id: false, name: 'No'}
                                        ]}
                                        elStyle={filterStyles.selectInput}
                                    />
                                </Fragment>
                            }
                            {includeFields.fraudLocked &&
                                <Fragment>
                                    <hr style={filterStyles.break}/>
                                    <Field
                                        name="fraud_locked"
                                        component={SelectInput}
                                        label="Fraud-locked Accounts?"
                                        choices={[
                                            {id: true, name: 'Yes'},
                                            {id: false, name: 'No'}
                                        ]}
                                        elStyle={filterStyles.selectInput}
                                    />
                                </Fragment>
                            }

                            {/* Date Range */}
                            {includeFields.dateRange &&
                                <DateRangeFields
                                    includeOffset={includeFields.offset}
                                    labelStartDate="Set First Date in Range *"
                                    labelEndDate="Set Last Date in Range *"
                                    labelOffset="Set Time Zone Offset *"
                                    startMinDate={startMinDate}
                                    startMaxDate={startMaxDate}
                                    endMaxDate={endMaxDate}
                                    onSelectStartDate={this.handleFieldUpdate}
                                    onSelectEndDate={this.handleFieldUpdate}
                                    onSelectOffset={this.handleFieldUpdate}
                                />
                            }

                            {/* Location Filters */}
                            {includeFields.locations &&
                                <div>
                                    <hr style={commonStyles.divider}/>
                                    <br/>
                                    <span>Select an optional secondary filter to narrow results, such as by a DBA, District, State, or desired Locations.</span>
                                    <br/>
                                </div>
                            }
                            <SecondaryFilterFieldsWithLocations
                                type="create"
                                displayFields={(includeFields.locations)}
                                includeLocationSubmit={false}
                                onFilterTypeSelect={(e) => this.handleFieldUpdate('filterSelect', e, null)}
                                onFilterChoiceSelect={(e) => this.handleFieldUpdate('filterChoice', e, null)}
                                onFilterLocations={(e) => this.handleFieldUpdate('filterLocations', e, null)}
                            />

                            {/* Top (Total Rows) */}
                            {includeFields.top === true &&
                                <Field
                                    name="top"
                                    component={renderTextInput}
                                    type="number"
                                    floatingLabelText="Total Results Requested *"
                                    step={1}
                                    min={1}
                                    max={10000}
                                    style={filterStyles.selectInputMedium}
                                    validate={[this.validateTop]}
                                    props={{
                                        floatingLabelFixed: true,
                                        defaultValue: 1,
                                        value: undefined
                                    }}
                                />
                            }
                        </Fragment>
                    }

                    {reportType &&
                        <div>
                            <hr style={commonStyles.divider}/>
                            <br/>
                            <RaisedButton
                                primary
                                type="button"
                                label="Create Report Job"
                                style={commonStyles.buttonInline}
                                disabled={(this.validateForm() === false || submitting || success)}
                                onClick={() => this.handleSubmit()}
                            />
                            <RaisedButton
                                type="button"
                                label="Cancel"
                                href="/#/ReportJobs"
                                disabled={(submitting || success)}
                                style={commonStyles.buttonInline}
                            />
                        </div>
                    }

                </form>
                <hr style={filterStyles.break}/>
                {submitted && !submitting && !success &&
                    <div className="error">
                        <p>Sorry, there was an issue creating Report Job "{formValues.name}". Please review
                        the form and try again.</p>
                    </div>
                }
                {submitted && !submitting && success &&
                    <div className="message">
                        <p>
                            Report Job "{formValues.name}" has been successfully created and is in
                            process. View
                            the <a href="#/ReportJobs" style={commonStyles.textLink}>Report Jobs List</a> to
                            check its progress.
                        </p>
                    </div>
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    let form = state.form['jobReportForm'];
    if (form && form.values) {
        return {
            formValues: form.values
        }
    }
    return {}
};

CreateReportJobForm.propTypes = {
    onFormComplete: PropTypes.func,
    submitted: PropTypes.bool,
    submitting: PropTypes.bool,
    success: PropTypes.bool
};

CreateReportJobForm.defaultProps = {
    submitted: false,
    submitting: false,
    success: false
};

const enhance = compose(
    connect(mapStateToProps),
    reduxForm({
        form: 'jobReportForm',
        enableReinitialize: true,
    })
);

export default enhance(CreateReportJobForm);



// WEBPACK FOOTER //
// ./src/Fuse/components/CreateReportJobForm.js